import {getStorableInfosFromTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import APIUtil from 'util/APIUtil';

/**
 * Given a typed value, try to extract a single plate.
 *
 * If no plate is found, or there's multiple, return null.
 */
export default function extractPlateId(typedValue: TypedValue | null): string | null {
  const storableInfos = getStorableInfosFromTypedValue(typedValue);
  if (storableInfos.length === 0) {
    return null;
  }
  if (storableInfos.length > 1) {
    return null;
  }

  const [storableInfo] = storableInfos;
  if (APIUtil.isPlate(storableInfo.id)) {
    return storableInfo.id;
  } else {
    return null;
  }
}
